// extracted by mini-css-extract-plugin
export var link = "header-module--link--qw-tf";
export var nav = "header-module--nav--2KHRF";
export var component = "header-module--component--102Mn";
export var logo = "header-module--logo--1W7Hc";
export var svg = "header-module--svg--1LMt6";
export var active = "header-module--active--3-IYD";
export var versionIndex = "header-module--version-index--1FohA";